import * as Sentry from "@sentry/nextjs";

import { sentryOptions } from "./sentry.options";

// Next подключает этот файл сам начиная с 15.3. На Next 14 без withSentryConfig
// он в сборку не попадает, клиентский Sentry в govoriru не инициализируется
Sentry.init({
  dsn:
    process.env.SENTRY_DSN ||
    "https://9318011a99f95582f1eb3d324c580938@sentry.jetclass.ru/9",
  tracesSampleRate: 1.0,
  ...sentryOptions,
});

// Трассировка навигации App Router; Next вызывает этот хук начиная с 15.3
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
